<script>
  import headers from '../data/headers-for-transactions-table.json';
  import { FILTER_TYPE } from '@/views/app/dashboard/history/data/constants';

  import DataTableSimple from '@/components/tables/DataTableSimple.vue';
  import HistoryFilter from '@/views/app/dashboard/history/components/HistoryFilter.vue';

  export default {
    name: 'TransactionHistory',

    components: { HistoryFilter, DataTableSimple },

    data: () => ({
      filter: {},

      headers,
      items: null,
    }),

    computed: {
      transactionHistory() {
        return this.$store.getters.getTransHistory;
      },

      transactionHistoryData() {
        const historyData = this.transactionHistory;

        historyData.sort((a, b) => {
          const da = new Date(a.date);
          const db = new Date(b.date);
          return db - da;
        });

        return historyData.map((item) => {
          if (item.type === FILTER_TYPE.Purchases) {
            return {
              ...item,
              amount: item.amount ? '$' + parseFloat(item.amount).toFixed(2) : '–',
            };
          } else if (item.type === FILTER_TYPE.Withdrawals) {
            return {
              ...item,
              amount: item.amount ? `$${item.amount}` : '–',
            };
          }
        });
      },
      filteredItems() {
        return this.items || this.transactionHistoryData;
      },
    },

    methods: {
      filterItems(items) {
        this.items = items;
      },
    },
    created() {
      if (!this.transactionHistory.length) {
        this.$store.dispatch('requestTransactionHistory');
      }
    },
  };
</script>

<template>
  <div>
    <history-filter :historyType="'transaction'" :items="transactionHistoryData" @filter="filterItems" />

    <v-row>
      <v-col className="mt-5" cols="12">
        <div class="table-container">
          <data-table-simple :headers="headers" :items="filteredItems" :items-per-page="10000" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>
